import { Api } from './setupApi';
import { API_URL } from '../constants/baseUrl';

const headers = {
  'Content-Type': 'application/json',
};

export const api = new Api(API_URL, headers);
